export class Piece {    
  location: string;
    id: number;
    color_id: number;
    color_name: string;
    color_supplier_name: string;
    design_id: number;
    design_name: string;
    design_supplier_name: string;
    collection_id: number;
    collection_name: string;
    collection_supplier_name: string;
    fabric_type_id: number;
    fabric_type_name: string;
    supplier_id: number;
    piece_id: any;
    piece_number: string;
    lot_number: string;
    length: number;
    full_length: number;
    weight: number;
    unit_price_eur: number;
    location_id: number;
    location_name: string;
    branch_id: number;
    branch_code: string;
    branch_name: string;
    deleted: boolean;
    last_updated: string;
    created_by: number;
    updated_by: number;    
    original_price: number;

    prepared_location_id: number;

    // For Sales, when it is actually sold
    sold: boolean;
    unit_price: number;
    quantity: number;
  tag: string;
}
  


// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/inventory/piece.ts